import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Filters_DEPRECATED } from '~/components/Shared/Filters_DEPRECATED/Filters_DEPRECATED';
import { Field } from '~/components/Shared/Filters_DEPRECATED/types';
import { Filter } from '~/evifields/src/types/Filter';
import { slices } from '~/redux/slices';

import {
  getAccessOptions,
  getCategoriesOptions,
  getDomainOptions,
} from './filterOptions';

export const IntegrationFilters = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const filters = useSelector(slices.newIntegrations.selectors.selectedFilters);

  const fields = useMemo((): Record<string, Field> => {
    return {
      domain: {
        id: 'domain',
        label: intl.formatMessage({
          id: 'Integrations.domain',
          defaultMessage: 'Domain',
          description: 'Domain filter label',
        }),
        type: 'enum_set',
        settings: {
          options: getDomainOptions(intl),
        },
        whitelistOperatorIds: ['contains_any'],
      },
      access: {
        id: 'access',
        label: intl.formatMessage({
          id: 'Integrations.access',
          defaultMessage: 'Access',
          description: 'Access filter label',
        }),
        type: 'enum_set',
        settings: {
          options: getAccessOptions(intl),
        },
        whitelistOperatorIds: ['contains_any'],
      },
      categories: {
        id: 'categories',
        label: intl.formatMessage({
          id: 'Integrations.categories',
          defaultMessage: 'Categories',
          description: 'Categories filter label',
        }),
        type: 'enum_set',
        settings: {
          options: getCategoriesOptions(intl),
        },
        whitelistOperatorIds: ['contains_any'],
      },
    };
  }, []);

  return (
    <Filters_DEPRECATED
      options={{
        disableRemoveFilter: true,
        disableManageFilters: true,
      }}
      fields={fields}
      filters={filters}
      onChange={(updatedFilters: Filter[]) => {
        dispatch(slices.newIntegrations.actions.setFilters(updatedFilters));
      }}
    />
  );
};
